import { Q, Query, Relation } from "@nozbe/watermelondb";
import {
  children,
  date,
  field,
  json,
  lazy,
  readonly,
  relation,
  text,
} from "@nozbe/watermelondb/decorators";
import { Associations } from "@nozbe/watermelondb/Model";
import {
  InventoryMovementFilter,
  InventoryMovementStatus,
  InventoryMovementTotals,
} from "@towersystems/roam-common/lib/generated-types";
import { noopSanitizeJSON } from "../utils";
import { BaseModel } from "./Base";
import Count from "./Count";
import InventoryMovementItem from "./InventoryMovementItem";
import Location from "./Location";
import Staff from "./Staff";

export default class InventoryMovement extends BaseModel {
  static table = "inventory_movements";

  static associations: Associations = {
    inventory_movement_items: {
      type: "has_many",
      foreignKey: "inventory_movement_id",
    },
  };

  @text("name") name: string | null;

  @text("reference_no") referenceNo: string | null;
  @text("status") status: InventoryMovementStatus;

  @date("inventory_movement_date") inventoryMovementDate: Date | null;
  @date("received_at") receivedAt: Date | null;
  @date("sent_at") sentAt: Date | null;
  @date("cancelled_at") cancelledAt: Date | null;
  @date("dispatched_at") dispatchedAt: Date | null;
  @date("due_at") dueAt: Date | null;
  @date("completed_at") completedAt: Date | null;

  @json("filters", noopSanitizeJSON) filters: InventoryMovementFilter[] | null;
  @json("totals", noopSanitizeJSON) totals: InventoryMovementTotals[] | null;

  @relation("staffs", "user_id") user: Relation<Staff>;
  @relation("locations", "location_id") location: Relation<Location>;
  @relation("locations", "target_location_id")
  targetLocationId: Relation<Location>;

  @children("inventory_movement_items")
  items: Query<InventoryMovementItem>;

  //@ts-ignore
  @lazy countedItems = this.items.extend(Q.where("counted", Q.notEq(null)));

  //@ts-ignore
  @lazy uncountedItems = this.items.extend(Q.where("counted", Q.eq(null)));

  // LOCAL ONLY - The following fields are not synced to the server
  @children("counts")
  localCounts: Query<Count>;

  get isFullStocktake() {
    return Array.isArray(this.filters) && this.filters.length === 0;
  }

  // If you require millisecond precision for your date fields in WatermelonDB,
  // you would need to implement a custom serialization and deserialization process.
  // this is sufficient for our use case
  @field("items_last_fetch_millis")
  itemsLastFetchMillis!: number;
}
